'use strict';

/** @type {import('./ref')} */
module.exports = ReferenceError;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/es-errors@1.3.0/~/es-errors/ref.js
// module id = 627
// module chunks = 0